window.faqTabs = () => {
    return {
        selectedPanel:'panel0',
        visible:false,
        init(){
            this.addGradient();
        },

        addGradient(){
            const tabs = document.querySelector('.faq-header-wrapper');
            const singleTab = document.getElementsByClassName('faq_header');
            const gradient = document.querySelector('.gradient-overlay');
            let tabsContainer = tabs.offsetWidth;
            let totalTabWidth = 0;

            for(let i = 0; i < singleTab.length; i++) {
                const rect = singleTab[i].getBoundingClientRect();
                totalTabWidth += parseInt(rect.width);
            };

            if (totalTabWidth > tabsContainer) {
                gradient.style.display = "block";
            } else {
                gradient.style.display = "none";
            }
        }
    }
}